module.exports = __webpack_public_path__ + "static/img/injectionProductionBanner.5b879460.png";